import _defineProperty from "/app/node_modules/.pnpm/next@12.3.3_4afada721a4a39e35a1a66028f2134fd/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { GoogleTagManagerEvent } from 'constants/google';
import { googleTagManagerTrack as track } from 'data/utils/google';
import { filterEmptyStringAttributes } from 'libs/utils/object';
import { getHost } from 'libs/utils/window';
import { getIsFeatureSwitchEnabled } from 'state/feature-switches/selectors';
import { getGoogleAnalyticsData } from 'state/selectors';
import { googleAnalyticsDataTransformer } from './google/utils';

function useGoogleTagManagerTrack() {
  const googleAnalyticsData = googleAnalyticsDataTransformer(useSelector(getGoogleAnalyticsData));
  const isGoogleAnalyticsTrackEnabled = useSelector(getIsFeatureSwitchEnabled('web_ga4_analytics'));
  const isGtmEcFieldEnabled = useSelector(getIsFeatureSwitchEnabled('web_gtm_ec_field'));
  const googleTagManagerTrack = useCallback((event, data) => track(event, data, isGtmEcFieldEnabled), [isGtmEcFieldEnabled]);
  const googleAnalyticsTrack = useCallback(_ref => {
    let {
      event = GoogleTagManagerEvent.pageLoad,
      customTagObject
    } = _ref;
    const eventObject = filterEmptyStringAttributes(_objectSpread(_objectSpread(_objectSpread({}, googleAnalyticsData), customTagObject), {}, {
      domain: getHost()
    }));

    if (isGoogleAnalyticsTrackEnabled) {
      track(event, eventObject);
    }
  }, [googleAnalyticsData, isGoogleAnalyticsTrackEnabled]);
  return {
    googleTagManagerTrack,
    googleAnalyticsTrack
  };
}

export default useGoogleTagManagerTrack;